import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import {
  OTHER_INCOME_STRUCTURE_ID,
  TOTAL_INCOME_STRUCTURE_ID,
} from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import ExportIncomeYearFieldsPct from './ExportIncomeYearFieldsPct';

const ExportIncomeDetailPct = () => {
  const { exportIncome } = useIncomeStructure();

  const domesticAndInternationalIncome = exportIncome?.filter(
    (item) =>
      item.id !== TOTAL_INCOME_STRUCTURE_ID.TOTAL_EXPORT_INCOME &&
      item.id !== OTHER_INCOME_STRUCTURE_ID.OTHER_EXPORT_INCOME
  );

  return (
    <>
      {domesticAndInternationalIncome?.map((item) => (
        <Flex key={item.id} width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }}>
              {item.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (%)
            </Typography>
          </Box>
          <ExportIncomeYearFieldsPct keyItem={item.id.toString()} />
        </Flex>
      ))}
    </>
  );
};

export default ExportIncomeDetailPct;
